var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3723 23.3337H4.66667C4.35725 23.3337 4.0605 23.2107 3.84171 22.992C3.62292 22.7732 3.5 22.4764 3.5 22.167V9.33366C3.5 8.09598 3.99167 6.909 4.86683 6.03383C5.742 5.15866 6.92899 4.66699 8.16667 4.66699H19.8333C21.071 4.66699 22.258 5.15866 23.1332 6.03383C24.0083 6.909 24.5 8.09598 24.5 9.33366V13.2828M8.16667 16.3337H11.6667M8.16667 11.667H15.1667",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2507 21.0003C20.8615 21.0003 22.1673 19.6945 22.1673 18.0837C22.1673 16.4728 20.8615 15.167 19.2507 15.167C17.6398 15.167 16.334 16.4728 16.334 18.0837C16.334 19.6945 17.6398 21.0003 19.2507 21.0003Z",
    stroke: "white",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.584 20.417L25.084 23.917",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.015b39b6fb08e827450d1541524411cd.svg";
export { ForwardRef as ReactComponent };